export default __webpack_public_path__ + "static/media/Book3.71f628ae.webp";